import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

// ============================================================
// FYUNOR — Hero Demo CTA
// The final resting state of the hero calculator preview.
// Rendered on the blue gradient (no white card) so the gradient
// remains visible. The link becomes focusable only when shown.
// ============================================================

export default function HeroDemoCTA({ focusable = true }) {
  return (
    <div className="flex h-full w-full flex-col items-start justify-center">
      <h3 className="font-heading text-xl font-semibold tracking-[var(--tracking-heading)] text-foreground text-balance">
        Ready to calculate your numbers?
      </h3>
      <p className="mt-2 font-body text-sm leading-relaxed text-muted-foreground text-balance">
        Try the full US Salary Calculator and see your estimated take-home pay in seconds.
      </p>
      <Button asChild size="lg" className="mt-4">
        <Link to="/us/calculators/salary" tabIndex={focusable ? undefined : -1}>
          Calculate My Salary
          <ArrowRight aria-hidden="true" />
        </Link>
      </Button>
      <p className="mt-3 font-body text-xs text-subtle-foreground">
        Free • No sign-up • Instant results
      </p>
    </div>
  );
}